import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { AgreementStatusesRequest } from './agreement-statuses-request';
import { AgreementStatusesResponse } from './agreement-statuses-response';

@Injectable({ providedIn: 'root' })
export class AgreementStatusesApi {
  constructor(private readonly afs: AngularFirestore) {}

  get(uid: string): Observable<AgreementStatusesResponse | undefined> {
    const agreementDoc = this.afs.doc<AgreementStatusesResponse>(
      `/agreement_statuses/${uid}`,
    );

    return agreementDoc.valueChanges();
  }

  set(uid: string, data: AgreementStatusesRequest): Promise<void> {
    const agreementDoc = this.afs.doc<AgreementStatusesResponse>(
      `/agreement_statuses/${uid}`,
    );
    return agreementDoc.set(data);
  }
}
